export default __webpack_public_path__ + "static/media/leftAlignedAssetTypeICon.92eb4770.svg";